import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Logo from '../../../elements/brand/Logo'
import Headroom from "./Headroom";

import NavLink from 'react-router-dom/NavLink'

import styles from './Header.sass';

export default class Header extends Component {

    static contextTypes = {
        layoutSetHasActiveOverlay: PropTypes.func,
        layoutHasInvertedTop: PropTypes.bool
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            unfixed: true,
            unpinned: false,
            navExpanded: false,
        };

        this.handleExpanderClick = this.handleExpanderClick.bind(this);
        this.handleNavClick = this.handleNavClick.bind(this);

        this.handleUnfix = this.handleUnfix.bind(this);
        this.handlePin = this.handlePin.bind(this);
        this.handleUnpin = this.handleUnpin.bind(this);
        this.setRootElementRef = this.setRootElementRef.bind(this);
    }

    handleNavClick(event) {
        if (this.state.navExpanded) {
            this.context.layoutSetHasActiveOverlay(false);
            this.setState({
                navExpanded: false
            })
        }
    }

    handleExpanderClick(event) {
        this.context.layoutSetHasActiveOverlay(!this.state.navExpanded);
        this.setState({
            navExpanded: !this.state.navExpanded
        })
    }

    handleUnfix() {
        this.setState({
            unfixed: true
        })
    }

    handlePin() {
        this.setState({
            unpinned: false
        })
    }

    handleUnpin() {
        this.setState({
            unfixed: false,
            unpinned: true
        })
    }

    setRootElementRef(ref) {
        this.$el = ref;
        this.setState({
            ready: true
        })
    }

    render() {
        return <header ref={this.setRootElementRef} className={classNames(styles.root, {
            [styles.unfixed]: this.state.unfixed,
            [styles.pinned]: !this.state.unpinned && !this.state.unfixed,
            [styles.inverted]: this.context.layoutHasInvertedTop,
            })}>
            {this.state.ready && <Headroom inner={this.$el} onUnfix={this.handleUnfix} onPin={this.handlePin} onUnpin={this.handleUnpin} />}
            <div className="larger grid">
                <svg viewBox="0 0 30 30">
                    <path d="M30 0v30s-8.57 0-13.37-7.07C13.8 18.77 0-.21 0-.21"/>
                </svg>
                <Logo Element={NavLink} className={styles.logo}
                      exact to="/"
                      title="Gamedev.js / Strona główna"
                      inverted={this.context.layoutHasInvertedTop || (!this.state.unpinned && !this.state.unfixed)}
                />
                <nav className={classNames({expanded: this.state.navExpanded})}>
                    <a className={styles.expander} onClick={this.handleExpanderClick}>
                        <i />
                        <i />
                        <i />
                    </a>
                    <ul>
                        <li><NavLink onClick={this.handleNavClick} to="/wydarzenia">Wydarzenia</NavLink></li>
                        <li><NavLink onClick={this.handleNavClick} to="/prelegenci">Prelegenci</NavLink></li>
                        <li><NavLink onClick={this.handleNavClick} to="/partnerzy">Partnerzy</NavLink></li>
                        <li><NavLink onClick={this.handleNavClick} to="/live">Live <i/></NavLink></li>
                        <li><NavLink onClick={this.handleNavClick} to="/kontakt">Kontakt</NavLink></li>
                    </ul>
                </nav>
                <svg viewBox="0 0 30 30" transform="scale(-1,1)">
                    <path d="M30 0v30s-8.57 0-13.37-7.07C13.8 18.77 0-.21 0-.21"/>
                </svg>
            </div>
        </header>
    }
}



// WEBPACK FOOTER //
// ./src/layouts/Default/Header/Header.js